import moment from 'moment-timezone';

export function simpleDate(unformattedDate) {
  const date = moment(unformattedDate);

  return `${date.date()} de ${date.format('MMMM')}`;
}

export function calendarDate(date) {
  return moment(date).calendar();
}
